import classNames from "classnames/bind";
import styles from "./ConfigVariable.module.css";
import { useContext, useEffect, useState } from "react";
import SettingAI from "../../../../Administration/Camera/Setting/SettingAI";
import { LisencePlateManagerContext } from "../../../../../contexts";
import { aiConfigService } from "../../../../../services/api/aiConfigService";

const cx = classNames.bind(styles);
const onClose = () => {

}
function ConfigVariable() {
    const { cameraCode } = useContext(LisencePlateManagerContext);
    const [aiConfig, setAiConfig] = useState();
    let codeService = '20230222000000000006';
    useEffect(() => {
        const getDefault = async () => {
            try {
                const res = await aiConfigService.getDefaultConfig(cameraCode)
                setAiConfig(res)
            } catch (error) {
                return 0;
            }
        }
        getDefault()
    }, [])
    return (
        <div>
            {
                cameraCode ? (
                    <SettingAI
                        cameraCode={cameraCode}
                        nameService={'Nhận dạng biển số xe'}
                        aiConfig={aiConfig}
                        setAiConfig={setAiConfig}
                        codeService={codeService}
                        onClose={onClose}
                    />
                ) : (
                    <div className={cx("empty")}>
                        <p>Vui lòng lựa chọn camera để cấu hình nhận dạng biển số xe!</p>
                    </div>
                )
            }
        </div>
    )
}

export default ConfigVariable;